const IconMap = {
  person: '\u0061',
  people: '\u0062',
  agent: '\u0063',
  aiChat: '\u0064',
  seat: '\u0065',
  addPerson: '\u0066',
  bag: '\u0067',
  bags: '\u0068',
  flight: '\u0069',
  car: '\u006A',
  hotel: '\u006B',
  rail: '\u006C',
  redo: '\u006D',
  oneWay: '\u006E',
  utensils: '\u006F',
  utensilsAlt: '\u0070',
  snack: '\u0071',
  wine: '\u0072',
  coffe: '\u0073',
  payment: '\u0074',
  cashPayment: '\u0075',
  swipe: '\u0076',
  promotion: '\u0077',
  boardingPass: '\u0078',
  oneDayPass: '\u0079',
  mobile: '\u007A',
  notMobile: '\u007B',
  phone: '\u007C',
  printer: '\u007D',
  website: '\u007E',
  email: '\u0030',
  time: '\u0031',
  wifi: '\u0032',
  mark: '\u0033',
  gps: '\u0034',
  power: '\u0035',
  play: '\u0036',
  search: '\u0037',
  message: '\u0038',
  filter: '\u0039',
  settings: '\u003A',
  lockOpen: '\u003B',
  lock: '\u003C',
  help: '\u003D',
  info: '\u003E',
  error: '\u003F',
  warning: '\u0040',
  newTab: '\u0041',
  more: '\u0042',
  menu: '\u0043',
  edit: '\u0044',
  calendar: '\u0045',
  list: '\u0046',
  checkSolid: '\u0047',
  roundTrip: '\u0048',
  timeSolid: '\u0049',
  notification: '\u004A',
  arrowUp: '\u004B',
  arrowDown: '\u004C',
  arrowLeft: '\u004D',
  arrowRight: '\u004E',
  check: '\u004F',
  cancel: '\u0050',
  circleUp: '\u0051',
  circleDown: '\u0052',
  circleLeft: '\u0053',
  circleRight: '\u0054',
  circleCheck: '\u0055',
  circleCancel: '\u0056',
  circlePlus: '\u0057',
  circleMinus: '\u0058',
  boxPlus: '\u0059',
  boxMinus: '\u005A',
  itinerary: '\u005D',
  slider: '\u005E',
  room: '\u005F',
  amenitie: '\u0060',
  starSolid: '\u00A1',
  halfStar: '\u00A2',
  star: '\u00A3',
  airConditioner: '\u00A4',
  door: '\u00A5',
  file: '\u00A6',
  export: '\u00A7',
  gift: '\u00A8',
  smartFare: '\u00A9',
  plane: '\u00AA',
  airport: '\u00AB',
  station: '\u00AC',
  corporate: '\u00AE',
  glasses: '\u00AF',
  classBasic: '\u00B0',
  classMain: '\u00B1',
  classPremium: '\u00B2',
  classBussiness: '\u00B3',
  classFirst: '\u00B4',
  classLuxury: '\u00B5',
  bike: '\u00B6',
  filterFilled: '\u00B7',
  chevronUp: '\u0020',
  chevronDown: '\u0021',
  chevronRight: '\u0022',
  chevronLeft: '\u0023',
  chevronCircleRight: '\u0024',
  chevronCircleLeft: '\u0025',
  transmission: '\u0027',
  mileage: '\u0028',
  share: '\u0029',
  plus: '\u002A',
  minus: '\u002B',
  chevronCircleUp: '\u005B',
  chevronCircleDown: '\u005C',
  safety: '\u00B8',
  passport: '\u00B9',
  camera: '\u00BA',
  change: '\u00BB',
  like: '\u00BC',
  clip: '\u00BD',
  building: '\u00D4',
  emailShare: '\u00BF',
  dollar: '\u002C',
  image: '\u002D',
  eye: '\u002E',
  eyeSlash: '\u002F',
  plusWithBag: '\u00C0',
  plusWithTime: '\u00c1',
  plusWithPerson: '\u00c2',
  plusWithClip: '\u00c3',
  planeDepart: '\u00c4',
  planeArrive: '\u00c5',
  governmentPolicy: '\u00c6',
  messageAlert: '\u00c7',
  chevronCircleSolidDown: '\u00c8',
  chevronCircleSolidUp: '\u00c9',
  calendarCheck: '\u00ca',
  bell: '\u00cb',
  virtualMeeting: '\u00cc',
  trash: '\u00cd',
  link: '\u00ce',
  meetingPlatform: '\u00cf',
  event: '\u00d0',
  plusWithCalendar: '\u00d1',
  payment_type: '\u00D2',
  calculator: '\u00D5', // Add the new icon here
};

export default IconMap;
